<template>
  <div>
    <AtomLoadingSecondary v-if="showLoadingState"/>

    <div v-else v-show="configParams || Object.values(autorizador.parametros).length">
      <form
        autocomplete="off"
        class="m-form"
        @submit.prevent="createAutorizador"
      >
        <h3 class="m-form-title">
          {{ `${$t('mEditionBillingFiscalAuthorizerConnectAuthorizer.title')} ${autorizador.nombre}` }}
        </h3>

        <div class="m-container-primary" id="params">

          <div class="row">
            <div class="column column-8">
              <p class="a-input-wrapper-column margin-top-medium">
                <label for="descripcion">{{ $t('mEditionBillingFiscalAuthorizerConnectAuthorizer.inputs.descripcion.label') }}</label>
                <input
                  id="descripcion"
                  class="a-input-primary"
                  name="descripcion"
                  v-model="autorizador.descripcion"
                  :class="{ 'a-input-danger': errors.descripcion }"
                  @blur="validateField('descripcion', autorizador.descripcion)"
                >
                <small v-show="errors.descripcion" class="text-color-danger">
                  {{ $t('mEditionBillingFiscalAuthorizerConnectAuthorizer.validation.required') }}
                </small>
              </p>
            </div>
          </div>

          <div class="row" style="display: flex; flex-wrap: wrap;" v-if="configParams">
            <div
              v-for="(field, key) in configParams"
              :key="key"
              class="column column-4"
              v-show="isVisible(key)"
            >
              <p class="a-input-wrapper-column margin-top-medium">

                <template v-if="field.type === 'download_button'">
                  <label>{{ field.label }}</label>
                  <button type="button" class="a-button-billing-primary a-button-primary" style="margin-top: 5px;">
                    Descargar PDF
                  </button>
                </template>

                <template v-else-if="field.type === 'select'">
                  <label :for="key">{{ field.label }}</label>
                  <select
                    :id="key"
                    :name="key"
                    class="a-input-primary"
                    v-model="formValues[key]"
                    :class="{ 'a-input-danger': hasError(key) }"
                    :disabled="field.edit === false"
                    @blur="markTouched(key)"
                    @change="handleSelectChange(key)"
                  >
                    <option value="">Seleccione una opción...</option>
                    <option v-for="opt in field.options" :key="opt" :value="opt.toLowerCase()">
                      {{ opt }}
                    </option>
                  </select>
                </template>

                <template v-else>
                  <label :for="key">{{ field.label }}</label>
                  <input
                    :id="key"
                    :name="key"
                    :type="field.type || 'text'"
                    class="a-input-primary"
                    v-model="formValues[key]"
                    :class="{ 'a-input-danger': hasError(key) }"
                    :placeholder="field.placeholder || ''"
                    :readonly="field.edit === false"
                    @blur="markTouched(key)"
                  >
                </template>

                <small v-show="hasError(key)" class="text-color-danger">
                  {{ $t('mEditionBillingFiscalAuthorizerEditAuthorizer.validation.required') }}
                </small>

                <br v-if="field.help">
                <small class="quote quote-billing-primary font-weight-regular font-size-small">
                  {{ field.help }}
                </small>

              </p>
            </div>
          </div>
        </div>

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.goBack"
          @goBackPage="goBackPage"
        />
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </form>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MoleculeEditionBillingFiscalAuthorizerConnectAuthorizer',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionBillingFiscalAuthorizerConnectAuthorizer.buttonPrimary'),
        class: 'margin-right-medium margin-top-medium',
        sending: false,
        type: 'submit'
      },
      buttonSecondary: {
        goBack: {
          text: this.$t('mEditionBillingFiscalAuthorizerEditAuthorizer.buttonSecondary'),
          class: 'margin-top-medium margin-right-medium',
          type: 'button',
          component: '',
          icon: 'fas fa-arrow-left',
          method: 'goBackPage'
        }
      },
      autorizador: {
        id: '',
        descripcion: '',
        nombre: '',
        parametros: {},
        autorizador: ''
      },
      showLoadingState: true,

      configParams: null,
      formValues: {},
      touchedFields: {},
      errors: {
        descripcion: false
      }
    }
  },

  computed: {
    currentEntityType () {
      return this.formValues['tipo_entidad'] || 'fisica'
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    if (Object.values(this.$store.getters.getBillingFiscalAuthorizer).length) {
      this.autorizador.nombre = this.$store.getters.getBillingFiscalAuthorizer.nombre
      this.autorizador.autorizador = this.$store.getters.getBillingFiscalAuthorizer.id
    } else {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.fiscalAuthorizer.subject')}`)
    }

    this.readAutorizadorConfiguracion()
  },

  methods: {
    goBackPage () {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.fiscalAuthorizer.subject')}`)
    },

    isVisible (key) {
      if (!key.includes('firmante')) return true

      const isFirmanteField = key.includes('firmante')

      if (this.currentEntityType === 'juridica') {
        return isFirmanteField
      } else {
        return !isFirmanteField
      }
    },

    markTouched (key) {
      this.$set(this.touchedFields, key, true)
    },

    hasError (key) {
      if (!this.isVisible(key)) return false

      const field = this.configParams[key]
      if (!field.required) return false

      return this.touchedFields[key] && !this.formValues[key]
    },

    validateField (field, value) {
      if (field === 'descripcion') {
        this.errors.descripcion = !value
      }
    },

    handleSelectChange (key) {
      if (key === 'tipo_entidad') {
        // Al cambiar de tipo, Vue recalcula automáticamente 'isVisible'
      }
    },

    createAutorizador () {
      this.validateField('descripcion', this.autorizador.descripcion)

      let hasDynamicErrors = false
      for (const key in this.configParams) {
        if (this.isVisible(key) && this.configParams[key].required && !this.formValues[key]) {
          this.$set(this.touchedFields, key, true)
          hasDynamicErrors = true
        }
      }

      if (this.errors.descripcion || hasDynamicErrors) {
        return
      }

      this.setAutorizador()

      this.showLoadingState = true
      this.$services.create('parametro', 'createAcademiaAutorizador', this.autorizador, [this.autorizador.autorizador, this.academiaId])
        .then(response => {
          let autorizador = {
            autorizador_fiscal: response.data.autorizador_fiscal,
            id_autorizador_fiscal: response.data.id_autorizador_fiscal
          }
          this.$store.commit('setBillingFiscalAuthorizerEdit', autorizador)
          this.showLoadingState = false
          this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.fiscalAuthorizer.subject')}/${this.$t('mEditionMenu.billing.fiscalAuthorizer.children.editAuthorizer.subedition')}`)
        })
        .catch(error => {
          this.showLoadingState = false
          this.$alerts.pushAlert('mEditionBillingFiscalAuthorizerConnectAuthorizer', 'createAutorizador', 'error', 'a-alert-danger')
          console.log(error)
        })
    },

    setAutorizador () {
      this.autorizador.parametros = { ...this.formValues }
    },

    readAutorizadorConfiguracion () {
      this.$services.read('parametro', 'readAutorizadorConfiguraciones', {}, [this.autorizador.autorizador, this.academiaId])
        .then(response => {
          if (typeof response.data === 'object') {
            this.configParams = response.data

            // Inicializamos valores
            const initValues = {}
            for (const key in response.data) {
              initValues[key] = response.data[key].value || ''
            }

            if (!initValues['tipo_entidad']) {
              initValues['tipo_entidad'] = 'fisica'
            }

            this.formValues = initValues
            this.autorizador.parametros = this.formValues
          } else {
            window.open(response.data, '_blank')
            this.$router.go(-1)
          }
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    }
  }
}
</script>
